import { render } from "./BigSign.vue?vue&type=template&id=e3203966"
import script from "./BigSign.vue?vue&type=script&lang=js"
export * from "./BigSign.vue?vue&type=script&lang=js"

import "./BigSign.vue?vue&type=style&index=0&id=e3203966&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__